module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "contents"
    }
  }, [_c('div', {
    staticClass: "generated-style"
  }, [_c('p', {
    staticClass: "x2fm-ttl",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "cover"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "#/Cover"
    }
  }, [_vm._v("Cover")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "title-page"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "#/Title_Page"
    }
  }, [_vm._v("Title Page")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "dedication"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "#/Dedication"
    }
  }, [_vm._v("Dedication")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-1"
    }
  }, [_c('p', {
    staticClass: "x2toc-after-txb1"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter_1#chapter-1"
    }
  }, [_vm._v("Chapter 1")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-2"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter_2#chapter-2"
    }
  }, [_vm._v("Chapter 2")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-3"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter_3#chapter-3"
    }
  }, [_vm._v("Chapter 3")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-4"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_4#chapter-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-5"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_5#chapter-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-6"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_6#chapter-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-7"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_7#chapter-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-8"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_8#chapter-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-9"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_9#chapter-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-10"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_10#chapter-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-11"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_11#chapter-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-12"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_12#chapter-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-13"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_13#chapter-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-14"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_14#chapter-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-15"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_15#chapter-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-16"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_16#chapter-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-17"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_17#chapter-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-18"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_18#chapter-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-19"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_19#chapter-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-20"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_20#chapter-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-21"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_21#chapter-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-22"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_22#chapter-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-23"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_23#chapter-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-24"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_24#chapter-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter-25"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_25#chapter-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "afterword"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Afterword#afterword",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "glossary"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('span', {
    attrs: {
      "href": "#/Glossary#glossary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Glossary of the Damned")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "acknowledgments"
    }
  }, [_c('p', {
    staticClass: "x2toc-after-txb1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/Acknowledgments#acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/About_the_Author#about-the-author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "also-by-the-author"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/Also_by_the_Author#also-by-the-author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Janet Mullany")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "credits"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/Credits#credits",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Credits")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "copyright"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/Copyright#copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "about-the-publisher"
    }
  }, [_c('p', {
    staticClass: "x2toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/About_the_Publisher#about-the-publisher",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a3ddcc0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 66
// module chunks = 0